import { render, staticRenderFns } from "./AiAssistantAgents.vue?vue&type=template&id=8cd9dfaa&scoped=true&"
import script from "./AiAssistantAgents.vue?vue&type=script&lang=js&"
export * from "./AiAssistantAgents.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantAgents.vue?vue&type=style&index=0&id=8cd9dfaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd9dfaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cd9dfaa')) {
      api.createRecord('8cd9dfaa', component.options)
    } else {
      api.reload('8cd9dfaa', component.options)
    }
    module.hot.accept("./AiAssistantAgents.vue?vue&type=template&id=8cd9dfaa&scoped=true&", function () {
      api.rerender('8cd9dfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/AiAssistantAgents.vue"
export default component.exports